import { Box, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useSessionContext } from 'session'

export const SearchPage: React.FC = () => {
  const { changeModuleName, changeUniqueId } = useSessionContext()

  useEffect(() => {
    changeModuleName('Search')
    changeUniqueId('')
  }, [changeModuleName])
  return (
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '80vh'
        }} className="centerAll">
    <Typography sx={{ mb: 4 }} variant="h5">US Data Search Page! 🇺🇸</Typography>
    </Box>
  )
}
